import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	updateButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	textAreaPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	updateButtonText: {
		id: 'jql-builder-basic-textarea.update-button-text',
		defaultMessage: 'Update',
		description: 'Submit action to update text-area value in the jql builder basic',
	},
	textAreaPlaceholder: {
		id: 'jql-builder-basic-textarea.text-area-placeholder',
		defaultMessage: 'Begin typing...',
		description: 'Text area placeholder in the jql builder basic',
	},
});
export default messages;
